// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-content label, .cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-content .cald_tree-item .form-check-label, .cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-header .cc_item-header .form-check-label, .cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .save-report-custom-tree .ui-widget-content, .cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .save-report-custom-tree, .cc_save-modal-setup .cc_save-modal-body .cald_report-share-container, .cc_save-modal-setup .cc_save-modal-body {
  font-family: "72-Regular";
}

.ng2-tag-input.ng2-tag-input {
  border-radius: 0.4rem;
  border: solid 0.1rem #ceced0;
  height: auto;
  padding: 0.4rem 0.4rem;
  overflow: auto;
}
.ng2-tag-input.ng2-tag-input .ng2-tag-input__text-input {
  height: 2.1rem;
}
.ng2-tag-input.ng2-tag-input tag {
  border-radius: 0.2rem;
  background-color: #eef5fc;
  padding: 0.2rem 0.4rem;
  font-size: 1.2rem;
  color: #515559;
  margin-right: 0.4rem;
  text-transform: capitalize;
  height: auto;
  line-height: normal;
}
.ng2-tag-input.ng2-tag-input tag delete-icon span {
  border: 0.1rem solid #0a6ed1;
  border-radius: 50%;
}
.ng2-tag-input.ng2-tag-input tag delete-icon svg {
  height: 1.8rem;
  width: 1.2rem;
  vertical-align: middle;
}
.ng2-tag-input.ng2-tag-input tag delete-icon svg path {
  fill: #0a6ed1;
}
.ng2-tag-input.ng2-tag-input tag delete-icon:hover {
  transform: none !important;
}
.ng2-tag-input.ng2-tag-input tag:hover {
  background-color: #eef5fc !important;
}

.cc_save-modal-setup {
  padding: 0rem !important;
}
.cc_save-modal-setup .cc_save-modal-body {
  padding: 1.6rem;
  height: auto !important;
  font-size: 1.4rem;
  background-color: #edeff0 !important;
}
.cc_save-modal-setup .cc_save-modal-body .save-reports-container {
  padding: 1.3rem 1.6rem 1.6rem;
  margin-bottom: 1.6rem;
}
.cc_save-modal-setup .cc_save-modal-body .save-reports-container .cc-multi-option-container {
  margin-top: 1.8rem;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container {
  font-size: 1.4rem;
  letter-spacing: 0;
  text-align: left;
  color: #515559;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container {
  overflow-y: auto;
  overflow-x: hidden;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .share-header {
  padding: 0.8rem 1.5rem;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .share-header .share-lbl {
  color: #32363a;
  font-size: 1.4rem;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .save-report-custom-tree {
  font-size: 1.2rem;
  letter-spacing: 0;
  text-align: left;
  color: #4a4a4a;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .save-report-custom-tree table thead {
  display: none;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .save-report-custom-tree .fa-caret-down:before {
  content: "\\f068";
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .save-report-custom-tree .fa-caret-right:before {
  content: "\\f067";
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .save-report-custom-tree .ui-state-highlight {
  border: none;
  background-color: #fff;
  color: #4a4a4a;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .save-report-custom-tree .ui-state-highlight a {
  color: #4a4a4a;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .save-report-custom-tree .ui-widget-content {
  border: none;
  font-size: 1.2rem;
  letter-spacing: 0;
  text-align: left;
  color: #4a4a4a !important;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .save-report-custom-tree .ui-widget-content a {
  color: #4a4a4a;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-header {
  display: block !important;
  border: 0px !important;
  padding: 0px !important;
  background: none !important;
  border-radius: 0px !important;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-header .cc_item-header {
  height: 3.3rem;
  background-color: #fff;
  border-top: 1px solid #e5e5e5;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-header .cc_item-header .cc_check-all {
  border-right: 0px !important;
  padding-top: 0.4rem;
  width: 5rem;
  height: 100%;
  text-align: center;
  margin-right: 1.2rem;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-header .cc_item-header .form-check-label {
  font-size: 1.5rem;
  margin-left: 1.3rem;
  color: #6f7275;
  margin-top: 0.8rem;
  font-weight: normal;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-content {
  margin-left: -2rem;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0px !important;
  border: none !important;
  border-radius: 0px !important;
  max-height: 25rem !important;
  padding-right: 0;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-content .treeview-item .treeview-item {
  margin-left: 0;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-content .treeview-item .treeview-item .cc_item-label-container {
  padding-left: 5rem;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-content .cald_tree-item {
  height: 3.3rem;
  background-color: #fff;
  border-top: 1px solid #e5e5e5;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-content .cald_tree-item.checked-item {
  background-color: rgba(18, 120, 221, 0.05);
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-content .cald_tree-item .form-check-label {
  font-size: 1.4rem;
  font-weight: normal;
  color: #515559;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-content .cald_tree-item .cc_item-label-container {
  margin-left: 1.4rem;
  padding-top: 0.4rem;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-content .cald_tree-item .cc_item-label-container .cc-arrow-icon {
  margin-right: 1.2rem;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-content .cald_tree-item .cc_item-check-container {
  width: 5rem;
  height: 100%;
  text-align: center;
  border-right: 1px solid #e5e5e5;
  padding-top: 0.7rem;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .p-panel-content label {
  color: #4a4a4a;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .tree-footer {
  padding: 0.3rem 0.4rem 0.3rem 1.6rem;
  background-color: #fff;
  border-top: 2px solid #e5e5e5;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .tree-footer .tree-pagination-field {
  display: inline-block;
  width: 4rem;
  height: 2.6rem;
  text-align: center;
  margin-right: 0.5rem;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .tree-footer em {
  display: inline-block;
  margin: 0 1.2rem;
}
.cc_save-modal-setup .cc_save-modal-body .cald_report-share-container .cald_share-list-container .tree-footer em:before {
  font-size: 1.2rem;
}

.p-component {
  font-size: 1.4rem;
}

.p-panel .p-panel-content:last-child {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  font-family: inherit;
}

.p-tree {
  border: none;
  padding: 0px;
  border-radius: 0px;
}

.p-treenode-content {
  height: 3.3rem;
  border-top: 1px solid #e5e5e5;
}

.p-element .cc_user-group-icon {
  margin-left: 1rem;
}

.p-tree-toggler-icon {
  width: 1.5rem;
  height: 1.5rem;
}

.p-checkbox {
  margin-left: 1rem;
}

.p-checkbox-box {
  width: 1.8rem;
  height: 1.8rem;
  border: 1.2px solid #ced4da !important;
  border-radius: 0.2rem;
}

.cc_check-all input {
  width: 3rem;
  height: 3rem;
  margin-left: 3.7rem;
  border: none;
}

.modal-custom-width.modal-dialog {
  min-width: 48.2rem !important;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/shared/save-modal/save-modal.component.scss","webpack://./src/app/assets/css/_variables.scss"],"names":[],"mappings":"AAIA,gHAAA;AAqBA;EACI,yBAAA;ACvBJ;;AAOA;EACE,qBAAA;EACA,4BAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AAJF;AAME;EACE,cAAA;AAJJ;AAOE;EACE,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,0BAAA;EACA,YAAA;EACA,mBAAA;AALJ;AAQM;EACE,4BAAA;EACA,kBAAA;AANR;AASM;EACE,cAAA;EACA,aAAA;EACA,sBAAA;AAPR;AASQ;EACE,aAAA;AAPV;AAWM;EACE,0BAAA;AATR;AAaI;EACE,oCAAA;AAXN;;AAgBA;EACE,wBAAA;AAbF;AAeE;EACE,eAAA;EACA,uBAAA;EAEA,iBAAA;EACA,oCAAA;AAdJ;AAgBI;EACE,6BAAA;EACA,qBAAA;AAdN;AAgBM;EACE,kBAAA;AAdR;AAkBI;EACE,iBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,cClFQ;ADiEd;AAmBM;EACE,gBAAA;EACA,kBAAA;AAjBR;AAmBQ;EACE,sBAAA;AAjBV;AAmBU;EACE,cC3FE;ED4FF,iBAAA;AAjBZ;AAqBQ;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAnBV;AAuBY;EACE,aAAA;AArBd;AAyBU;EACE,gBAAA;AAvBZ;AA0BU;EACE,gBAAA;AAxBZ;AA2BU;EACE,YAAA;EACA,sBAAA;EACA,cAAA;AAzBZ;AA2BY;EACE,cAAA;AAzBd;AA6BU;EACE,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AA3BZ;AA8BY;EACE,cAAA;AA5Bd;AAiCQ;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;AA/BV;AAiCU;EACE,cAAA;EACA,sBAAA;EACA,6BAAA;AA/BZ;AAiCY;EACE,4BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;AA/Bd;AAkCY;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EAEA,kBAAA;EACA,mBAAA;AAjCd;AAsCQ;EAGE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,gBAAA;AAtCV;AAyCY;EACE,cAAA;AAvCd;AAyCc;EACE,kBAAA;AAvChB;AA4CU;EACE,cAAA;EACA,sBClMJ;EDmMI,6BAAA;AA1CZ;AA4CY;EACE,0CAAA;AA1Cd;AA6CY;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;AA3Cd;AA+CY;EACE,mBAAA;EACA,mBAAA;AA7Cd;AA+Cc;EACE,oBAAA;AA7ChB;AAiDY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,mBAAA;AA/Cd;AAmDU;EAEE,cAAA;AAlDZ;AAsDQ;EACE,oCAAA;EACA,sBAAA;EACA,6BAAA;AApDV;AAsDU;EACE,qBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;AApDZ;AAuDU;EACE,qBAAA;EACA,gBAAA;AArDZ;AAuDY;EACE,iBAAA;AArDd;;AA8DA;EACE,iBAAA;AA3DF;;AA8DA;EACE,+BAAA;EACA,8BAAA;EACA,oBAAA;AA3DF;;AA+DA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;AA5DF;;AA+DA;EACE,cAAA;EACA,6BAAA;AA5DF;;AA+DA;EACE,iBAAA;AA5DF;;AA+DA;EACE,aAAA;EACA,cAAA;AA5DF;;AA+DA;EACE,iBAAA;AA5DF;;AA+DA;EACE,aAAA;EACA,cAAA;EACA,sCAAA;EACA,qBAAA;AA5DF;;AA+DA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AA5DF;;AAgEE;EAEE,6BAAA;AA9DJ","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../assets/css/fonts';\n\n.cc-save-modal-dialog {\n  .modal-content {\n    @media (min-width: 768px) {\n      // width: 48.2rem;\n    }\n  }\n}\n\n.ng2-tag-input.ng2-tag-input {\n  border-radius: 0.4rem;\n  border: solid 0.1rem #ceced0;\n  height: auto;\n  padding: 0.4rem 0.4rem;\n  overflow: auto;\n\n  .ng2-tag-input__text-input {\n    height: 2.1rem;\n  }\n\n  tag {\n    border-radius: 0.2rem;\n    background-color: #eef5fc;\n    padding: 0.2rem 0.4rem;\n    font-size: 1.2rem;\n    color: #515559;\n    margin-right: 0.4rem;\n    text-transform: capitalize;\n    height: auto;\n    line-height: normal;\n\n    delete-icon {\n      span {\n        border: 0.1rem solid #0a6ed1;\n        border-radius: 50%;\n      }\n\n      svg {\n        height: 1.8rem;\n        width: 1.2rem;\n        vertical-align: middle;\n\n        path {\n          fill: #0a6ed1;\n        }\n      }\n\n      &:hover {\n        transform: none !important;\n      }\n    }\n\n    &:hover {\n      background-color: #eef5fc !important;\n    }\n  }\n}\n\n.cc_save-modal-setup {\n  padding: 0rem !important;\n\n  .cc_save-modal-body {\n    padding: 1.6rem;\n    height: auto !important;\n    @extend %font-regular;\n    font-size: 1.4rem;\n    background-color: #edeff0 !important;\n\n    .save-reports-container {\n      padding: 1.3rem 1.6rem 1.6rem;\n      margin-bottom: 1.6rem;\n\n      .cc-multi-option-container {\n        margin-top: 1.8rem;\n      }\n    }\n\n    .cald_report-share-container {\n      font-size: 1.4rem;\n      @extend %font-regular;\n      letter-spacing: 0;\n      text-align: left;\n      color: $label-value;\n\n      .cald_share-list-container {\n        overflow-y: auto;\n        overflow-x: hidden;\n\n        .share-header {\n          padding: 0.8rem 1.5rem;\n\n          .share-lbl {\n            color: $title-color;\n            font-size: 1.4rem;\n          }\n        }\n\n        .save-report-custom-tree {\n          font-size: 1.2rem;\n          letter-spacing: 0;\n          text-align: left;\n          color: #4a4a4a;\n          @extend %font-regular;\n\n          table {\n            thead {\n              display: none;\n            }\n          }\n\n          .fa-caret-down:before {\n            content: '\\f068';\n          }\n\n          .fa-caret-right:before {\n            content: '\\f067';\n          }\n\n          .ui-state-highlight {\n            border: none;\n            background-color: #fff;\n            color: #4a4a4a;\n\n            a {\n              color: #4a4a4a;\n            }\n          }\n\n          .ui-widget-content {\n            border: none;\n            font-size: 1.2rem;\n            letter-spacing: 0;\n            text-align: left;\n            color: #4a4a4a !important;\n            @extend %font-regular;\n\n            a {\n              color: #4a4a4a;\n            }\n          }\n        }\n\n        .p-panel-header {\n          display: block !important;\n          border: 0px !important;\n          padding: 0px !important;\n          background: none !important;\n          border-radius: 0px !important;\n\n          .cc_item-header {\n            height: 3.3rem;\n            background-color: #fff;\n            border-top: 1px solid #e5e5e5;\n\n            .cc_check-all {\n              border-right: 0px !important;\n              padding-top: 0.4rem;\n              width: 5rem;\n              height: 100%;\n              text-align: center;\n              margin-right: 1.2rem;\n            }\n\n            .form-check-label {\n              font-size: 1.5rem;\n              margin-left: 1.3rem;\n              color: #6f7275;\n              @extend %font-regular;\n              margin-top: 0.8rem;\n              font-weight: normal;\n            }\n          }\n        }\n\n        .p-panel-content {\n          // max-height: 100% !important;\n          // overflow: hidden;\n          margin-left: -2rem;\n          overflow-x: hidden;\n          overflow-y: auto;\n          padding: 0px !important;\n          border: none !important;\n          border-radius: 0px !important;\n          max-height: 25rem !important;\n          padding-right: 0;\n\n          .treeview-item {\n            .treeview-item {\n              margin-left: 0;\n\n              .cc_item-label-container {\n                padding-left: 5rem;\n              }\n            }\n          }\n\n          .cald_tree-item {\n            height: 3.3rem;\n            background-color: $white;\n            border-top: 1px solid #e5e5e5;\n\n            &.checked-item {\n              background-color: rgba(18, 120, 221, 0.05);\n            }\n\n            .form-check-label {\n              font-size: 1.4rem;\n              font-weight: normal;\n              color: #515559;\n              @extend %font-regular;\n            }\n\n            .cc_item-label-container {\n              margin-left: 1.4rem;\n              padding-top: 0.4rem;\n\n              .cc-arrow-icon {\n                margin-right: 1.2rem;\n              }\n            }\n\n            .cc_item-check-container {\n              width: 5rem;\n              height: 100%;\n              text-align: center;\n              border-right: 1px solid #e5e5e5;\n              padding-top: 0.7rem;\n            }\n          }\n\n          label {\n            @extend %font-regular;\n            color: #4a4a4a;\n          }\n        }\n\n        .tree-footer {\n          padding: 0.3rem 0.4rem 0.3rem 1.6rem;\n          background-color: #fff;\n          border-top: 2px solid #e5e5e5;\n\n          .tree-pagination-field {\n            display: inline-block;\n            width: 4rem;\n            height: 2.6rem;\n            text-align: center;\n            margin-right: 0.5rem;\n          }\n\n          em {\n            display: inline-block;\n            margin: 0 1.2rem;\n\n            &:before {\n              font-size: 1.2rem;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.p-component {\n  font-size: 1.4rem;\n}\n\n.p-panel .p-panel-content:last-child {\n  border-bottom-right-radius: 0px;\n  border-bottom-left-radius: 0px;\n  font-family: inherit;\n}\n\n\n.p-tree {\n  border: none;\n  padding: 0px;\n  border-radius: 0px;\n}\n\n.p-treenode-content {\n  height: 3.3rem;\n  border-top: 1px solid #e5e5e5;\n}\n\n.p-element .cc_user-group-icon {\n  margin-left: 1rem;\n}\n\n.p-tree-toggler-icon {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.p-checkbox {\n  margin-left: 1rem;\n}\n\n.p-checkbox-box {\n  width: 1.8rem;\n  height: 1.8rem;\n  border: 1.2px solid #ced4da !important;\n  border-radius: 0.2rem;\n}\n\n.cc_check-all input {\n  width: 3rem;\n  height: 3rem;\n  margin-left: 3.7rem;\n  border: none;\n}\n\n.modal-custom-width {\n  &.modal-dialog {\n    // This will replace default width of the modal which is set in modal.scss\n    min-width: 48.2rem !important;\n  }\n}","$label-color: #6f7275;\n$label-value: #515559;\n$title-color: #32363a;\n$actions-color: #0a6ed1;\n$bg-color: #edeff0;\n$white: #fff;\n$shell-bg-color: #354a5f;\n$nav-bg-color:#F8F9FA;\n$placeholder-image-bg-color: #eeeeef;\n$text-action-hover-color: #fafafa;\n$text-action-click-color: #eeeeef;\n$active-input-color: #eef5fc;\n$error-color: #ee0000;\n$warning-offline-color: #e9730c;\n$success-color: #118843;\n$input-text-color: #32363a;\n$form-field-disable-color: #fafafa;\n$divider-color: #e5e5e5;\n$warning-bg-color:#fef7f1;\n$danger-color: #bb0000;\n$green-text: #107f3e;\n\n// buttons\n$primary-btn-color: #0a6ed1;\n$primary-btn-hover-color: #085caf;\n$primary-btn-active-color: #0854a1;\n$primary-btn-border-color: #367db8;\n$toggle-down-color: #0854a1;\n$shell-icon-color: #d1e3ff;\n$shell-hover-color: #485b6e;\n$shell-icon-active-color: #919ba7;\n$sidebar-icon-color: #313336;\n\n//Bootstrap5 migration\n$btn-primary-color: #337ab7;\n$btn-primary-active-color: #2e6da4;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
